<mat-accordion class="table clean plain" multi>
  <app-table-list-view-group
    [group]="root"
    [headers]="headers"
    [options]="options"
    (rowSelection)="rowSelection.emit()"
    (prefixEvent)="prefixEvent.emit($event)"
    (sort)="sort.emit($event)"
  />
</mat-accordion>
